import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Routes from './core/Routes';
import * as serviceWorker from './serviceWorker';
import configureStore from './core/ConfigureStore';
import {Provider} from 'react-redux';
import 'bootstrap/dist/js/bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'toastr/build/toastr.min.css';
import 'font-awesome/css/font-awesome.css';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import "react-datepicker/dist/react-datepicker.css";
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

const store = configureStore();

ReactDOM.render(
    <Provider store={store}>
        <Routes/>
    </Provider>, 
    document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
